import { createFileRoute, notFound } from "@tanstack/react-router";
import { CatalogChildPage } from "@/components/sections/catalog-pages";
import { getCatalogChild } from "@/lib/services-catalog";

export const Route = createFileRoute("/services/hrm-payroll/$child")({
  component: HrmChild,
  head: ({ params }) => {
    const found = getCatalogChild("hrm-payroll", params.child);
    const title = found ? `${found.item.title} — HRM & Payroll — CoderLity` : "HRM & Payroll — CoderLity";
    const desc = found?.item.desc ?? "People operations, hiring to payroll.";
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: `/services/hrm-payroll/${params.child}` },
      ],
      links: [{ rel: "canonical", href: `https://coderlity.com/services/hrm-payroll/${params.child}` }],
    };
  },
});

function HrmChild() {
  const { child } = Route.useParams();
  const found = getCatalogChild("hrm-payroll", child);
  if (!found) throw notFound();
  return <CatalogChildPage cat={found.cat} item={found.item} />;
}
